import React, { useContext, useEffect } from "react";
import VariantBuilderSetting from "../variants/VariantBuilderSetting";
import { VariantContextData } from "../variants/VariantBuilderContext";
import { conditionKeywordUpdates } from "../../utils/conditionFieldSync";

const QuizAnswerSettings = (props) => {
  const [contextData, builder] = useContext(VariantContextData);

  const element = props.element;
  const field_option = props.field_option;
  const field_option_item = props.field;

  const field = field_option_item;

  return (
    <React.Fragment
      key={`quiz-field-${field_option_item.id}-option-${field_option.id}`}
    >
      <VariantBuilderSetting
        object={field_option}
        setting_name="[modal_trigger]"
        setting_type="item_v2"
        object_type="field_options"
        object_id={field_option.id}
        title={field_option.label || field_option.value}
        condition={element.element_type == "quiz"}
        style={{ margin: "0px" }}
        position={field_option.position}
        label_prepend={(props.index + 10).toString(36).toUpperCase()}
        label_icon={
          field_option_item.field_type == "icon"
            ? field_option.icon
            : props.quizLabelIcon
            ? props.quizLabelIcon(field_option_item.field_type)
            : ""
        }
        panel_type="modal"
        side_panel={true}
        label_max_length={20}
        label_hover_max_length={16}
        duplicate_payload={{
          field_id: `${field_option_item.id}`,
          label: `${field_option.label} (copy)`,
        }}
      >
        <VariantBuilderSetting
          key={`label-${field_option.id}-${field_option.label || ""}`}
          object={field_option}
          setting_name="[label]"
          label="Answer Label"
          setting_type="text"
          object_type="field_options"
          object_id={field_option.id}
          value={field_option.label ? field_option.label : ""}
          condition={element.element_type == "quiz"}
        />

        <VariantBuilderSetting
          object={field_option}
          setting_name="[label]"
          setting_type="remix_content"
          object_type="field_options"
          object_id={field_option.id}
          value={field_option.label}
          condition={element.element_type == "quiz"}
        />

        <VariantBuilderSetting
          object={field_option}
          setting_name="[value]"
          label="Data Value"
          setting_type="text"
          placeholder={field_option.label}
          object_type="field_options"
          object_id={field_option.id}
          value={field_option.value ? field_option.value : ""}
          condition={element.element_type == "quiz"}
          no_commas={
            [
              "survey",
              "dropdown",
              "select",
              "image",
              "color",
              "emoji",
              "icon",
              "letter",
              "checkbox",
              "radio_survey",
            ].includes(field.field_type) &&
            (field.multi_select + "" == "true" ||
              field.field_type == "checkbox")
          }
          skip_history={true}
          callback={(new_value, old_value) => {
            builder.update([
              {
                object_type: "field_options",
                object_id: field_option.id,
                setting_name: "[value]",
                value: new_value,
                old_value: old_value,
              },
              ...conditionKeywordUpdates(
                contextData.objects.variant,
                field,
                field_option,
                new_value,
                old_value
              ),
            ]);
          }}
        />

        <VariantBuilderSetting
          object={field_option}
          label="Skip multiselect if selected"
          setting_name="[options][skip-multiselect-on-select]"
          setting_type="checkbox"
          object_type="field_options"
          object_id={field_option.id}
          value={
            field_option.options &&
            field_option.options["skip-multiselect-on-select"] == "true"
          }
          tooltip="Auto-advance to the next question when this answer is selected, even if the question allows multiple selections."
          tooltip_position="right"
          condition={
            element.element_type == "quiz" && field.multi_select + "" == "true"
          }
        />

        <VariantBuilderSetting
          object={field_option}
          label="Conditional Content"
          setting_name="[options][conditional-content]"
          setting_type="editor"
          object_type="field_options"
          object_id={field_option.id}
          value={
            (field_option.options &&
              field_option.options["conditional-content"]) ||
            ""
          }
          tooltip="Content shown when this answer is selected. Use quiz conditional content design settings to style the container and placement."
          tooltip_position="right"
          condition={element.element_type == "quiz"}
          editor_live_preview={false}
          allow_empty={true}
        />

        <VariantBuilderSetting
          object={field_option}
          label="Image"
          setting_name="[image]"
          setting_type="image"
          object_type="field_options"
          object_id={field_option.id}
          value={field_option.image ? field_option.image : ""}
          padding="0px"
          condition={
            element.element_type == "quiz" &&
            field_option_item.field_type === "image"
          }
        />

        <VariantBuilderSetting
          object={field_option}
          label="Icon"
          setting_name="[icon]"
          setting_type="icon"
          object_type="field_options"
          object_id={field_option.id}
          value={field_option.icon}
          condition={
            element.element_type == "quiz" &&
            field_option_item.field_type === "icon"
          }
        />

        <VariantBuilderSetting
          object={field_option}
          label="Letter"
          setting_name="[letter]"
          setting_type="text"
          maxLength={1}
          object_type="field_options"
          object_id={field_option.id}
          value={field_option.letter}
          condition={
            element.element_type == "quiz" &&
            field_option_item.field_type === "letter"
          }
        />

        <VariantBuilderSetting
          object={field_option}
          label="Color"
          setting_name="[color]"
          setting_type="color_v2"
          object_type="field_options"
          object_id={field_option.id}
          value={field_option.color}
          placeholder="#000"
          condition={
            element.element_type == "quiz" &&
            field_option_item.field_type === "color"
          }
        />

        <VariantBuilderSetting
          object={field_option}
          label="Emoji"
          setting_name="[emoji]"
          setting_type="emoji"
          object_type="field_options"
          object_id={field_option.id}
          value={field_option.emoji}
          condition={
            element.element_type == "quiz" &&
            field_option_item.field_type === "emoji"
          }
        />

        <VariantBuilderSetting
          object={field_option}
          label="Score"
          setting_name="[score]"
          setting_type="range"
          object_type="field_options"
          object_id={field_option.id}
          value={field_option.score + "" ? field_option.score : ""}
          min={-1000}
          max={1000}
          step={1}
          tooltip={
            "Assigning a score to this field option will increment the visitor's current score for the CTA"
          }
          tooltip_position="right"
          condition={field_option_item.field_type !== "range"}
          feature_gate_type="Funnel Score"
        />
      </VariantBuilderSetting>
    </React.Fragment>
  );
};

export default QuizAnswerSettings;
